// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  ScoreCard,
  GameTypeTab,
  StatsGraph,
  AllGametypeTab
}                         from '../../../components';

import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import styles                 from './style';
import { Spinner } from 'react-activity';
import ReactTable from "react-table"; 
import moment from "moment";
import DatePicker from 'react-datepicker';
import Card from '../../../components/card/Card';
import styled from 'styled-components';
import ActiveCustomers from '../../partner/activeCustomers';
const is_mobile = device.mobile;  
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

class CustomerDetails extends PureComponent {  

  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      customer_data: [],
      customer_headers: [],
      active_cust_count: 0,
      customer_details: true,
      paid_customer: false,
      excel_data:[],
      report_no:7537,
      report_name:'All Active Customers',
      loading: true,
      clicked_first: true,
      active_customer_data: [],
      active_customer_header: [],
      loader: false
    };
    this.handleSelection = this.handleSelection.bind(this);
    this.onCustomerClick = this.onCustomerClick.bind(this);
    this.locationChanged = this.locationChanged.bind(this);
    this.onPaidCustomerClick = this.onPaidCustomerClick.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerDashboard');
  }

  componentDidMount() {
    this.getCustomers()
    this.getActiveCustomersToday()
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    // $('.avtive_customers').find("a").trigger("click");
    // $('.monthly_revenue').find("a").trigger("click");
    if(!this.state.section){
      this.setState({section:'ActiveCustomer'});
    }
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerDashboard');
  }


  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id,loading:true}, () => {
      this.getCustomers()
      this.getActiveCustomersToday()   
    })
  }

  getStats() {
    const url = `${getLocationOrigin()}/cm/get_dashboard_stats/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({active_cust_count:data.active_cust})
           // alert("fix");
       }).catch(error => error);
  }

  getActiveCustomersToday() {
    this.setState({loader:true})
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=75370&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({active_customer_data:data.data,active_customer_header:data.headers,loader:false})
       }).catch(error => error);
  }

  getCustomers() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=${this.state.report_no}&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({customer_data:data.data,customer_headers:data.headers,excel_data:data.excel_data,loading:false})
           // alert("fix");
       }).catch(error => error);
  }

  handleSelection(event){
    const name = event.target.name;
    if(name == 'pay_n_play'){
      this.setState({report_no:75371,report_name:'Active Customers - Pay and Play'},()=>{this.getCustomers()});
    }
    else if(name == 'renewal'){
      this.setState({report_no:75372,report_name:'Active Customers - Renewals'},()=>{this.getCustomers()});
    }
    else if(name == 'all_customers'){
      this.setState({report_no:7537,report_name:'All Active Customers'},()=>{this.getCustomers()});
    }
    else{
      this.setState({report_no:75373,report_name:'New Active Customers'},()=>{this.getCustomers()});
    }
  }

  renderActiveToday(){
    var active_headers = []
    if(this.state.active_customer_header.length > 0){
      var active_tab_index = []
      for (var i = 0; i < this.state.active_customer_header.length; i++) {
        if(this.state.active_customer_header[i].indexOf("_hidden") == -1){
          active_headers.push(this.state.active_customer_header[i]);
          active_tab_index.push(i);
        }
      }
    }

    return (

      <div className='col-md-12 table_container1' style={{marginTop:'1%',overflowX:'auto'}}>
        <div className="heading heading2 left" style={{marginTop:'1%',marginBottom:'1%',padding:'10px',fontSize:'18px',textAlign:'center',borderRadius:'5px',boxShadow: '0px 0px 2px 0px'}}>
          Active Customers - Today
        </div> 
        
        {this.state.loader ?
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%'}}> <Spinner size="50" /></div>
          </div>
        :
          this.state.active_customer_data.length == 0 ?
            <div style={{textAlign:'center',marginBottom:'1%'}}>
              No Data Available
            </div>
        :
          <table className="table_plain">
            <tr> 
              {active_headers.map((head)=>
                <th style={{padding:'10px',textAlign:'center'}}>{head}</th>
              )
            }
            </tr>
            
            { this.state.active_customer_data && this.state.active_customer_data.length > 0 &&
              this.state.active_customer_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    active_tab_index.includes(key) &&
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
              )
            }
          </table>
        }
      </div>
    )
  }

  renderCustomers(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.customer_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.customer_headers.length; i++) {
        if(this.state.customer_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.customer_headers[i]);
          tab_index.push(i);
        }
      }
    }
    
    
    return(
      <div>

        <div className='col-md-12'>
          <div className='col-xs-4' style={styles.headerContainer}> <Tabs style={{backgroundColor:this.state.report_no == 7537 && 'green',color:this.state.report_no == 7537 && 'white'}} name='all_customers' onClick={()=>this.setState({clicked_first:true,report_no:7537,report_name:'All Active Customers',loading:true},()=>{this.getCustomers()})}> Active Customers </Tabs> </div>
          <div className='col-xs-4' style={styles.headerContainer}> <Tabs style={{backgroundColor:this.state.report_no == 75371 && 'green',color:this.state.report_no == 75371 && 'white'}} name='pay_n_play' onClick={()=>this.setState({clicked_first:false,report_no:75371,report_name:'Active Customers - Pay and Play',loading:true},()=>{this.getCustomers()})}> Pay and Play </Tabs> </div>
          <div className='col-xs-4' style={styles.headerContainer}> <Tabs style={{backgroundColor:this.state.report_no == 75372 && 'green',color:this.state.report_no == 75372 && 'white'}} name='renewal' onClick={()=>this.setState({clicked_first:false,report_no:75372,report_name:'Active Customers - Renewed',loading:true},()=>{this.getCustomers()})}> Renewed Customers </Tabs> </div>
          <div className='col-xs-4' style={styles.headerContainer}> <Tabs style={{backgroundColor:this.state.report_no == 75373 && 'green',color:this.state.report_no == 75373 && 'white'}} name='new_customers' onClick={()=>this.setState({clicked_first:false,report_no:75373,report_name:'New Active Customers',loading:true},()=>{this.getCustomers()})}> New Customers</Tabs> </div>
          <div className='col-xs-4' style={styles.headerContainer}> <Tabs style={{backgroundColor:this.state.report_no == 75376 && 'green',color:this.state.report_no == 75376 && 'white'}} name='expiring_customers' onClick={()=>this.setState({clicked_first:false,report_no:75376,report_name:'Expiring Customers',loading:true},()=>{this.getCustomers()})} >  Expiring Customers</Tabs> </div>
          <div className='col-xs-4' style={styles.headerContainer}> <Tabs style={{backgroundColor:this.state.report_no == 75377 && 'green',color:this.state.report_no == 75377 && 'white'}} name='potential_customers' onClick={()=>this.setState({clicked_first:false,report_no:75377,report_name:'Potential Customers This Month',loading:true},()=>{this.getCustomers()})}> Potential Customers</Tabs> </div>
          <div className='col-xs-4' style={styles.headerContainer}> <Tabs style={{backgroundColor:this.state.report_no == 31404 && 'green',color:this.state.report_no == 31404 && 'white'}} name='played_after_expiry' onClick={()=>this.setState({clicked_first:false,report_no:31404,report_name:'Played After Expiry Customers',loading:true},()=>{this.getCustomers()})}> Played After Expiry</Tabs> </div>
        </div>
      
{/*      {
        this.state.clicked_first &&
          <div className='col-md-12 col-xs-12'>
            <div className='col-md-2 col-xs-4' style={{display:'flex',justifyContent: 'center',alignItems:'center'}}> <SubTabs style={{backgroundColor:this.state.report_no == 7537 && '#00800099',color:this.state.report_no == 7537 && 'white' }} name='all_customers' onClick={()=>this.setState({report_no:7537,report_name:'All Active Customers',loading:true},()=>{this.getCustomers()})}> Monthly </SubTabs> </div>
            <div className='col-md-2 col-xs-4' style={{display:'flex',justifyContent: 'center',alignItems:'center'}}> <SubTabs style={{backgroundColor:this.state.report_no == 75370 && '#00800099',color:this.state.report_no == 75370 && 'white'}} name='active_customers_today' onClick={()=>this.setState({report_no:75370,report_name:'Active Customers - Today',loading:true},()=>{this.getCustomers()})}> Today </SubTabs> </div>
          </div>
      } 
*/}
        {
          this.state.report_no == 7537 &&
          this.renderActiveToday()
        }
      
        <div className='col-md-12 col-xs-12' style={{textAlign:'right',marginTop: is_mobile() ? '2%' :'1%',marginBottom: is_mobile() && '2%'}}>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button btn btn-primary"
            table="table-to"
            filename="Active Customers"
            sheet="Active Customers"
            buttonText="Download as XLS"/>
        </div>
      
        <div className='col-md-12 table_container1' style={styles.table}>
          <div className="heading heading2 left" style={{marginTop:'1%',marginBottom:'2%',padding:'10px',fontSize:'18px',textAlign:'center',borderRadius:'5px',boxShadow: '0px 0px 2px 0px'}}>
            {this.state.report_name}
          </div> 
          {!this.state.loading ?
            <table className="table_plain">
              <tr> 
                {headers.map((head)=>
                  <th style={{padding:'10px',textAlign:'center'}}>{head}</th>
                )
              }
              </tr>
              
              { this.state.customer_data && this.state.customer_data.length > 0 ?
                this.state.customer_data.map((data)=>
                  <tr>
                    { data.map((each,key)=>
                      tab_index.includes(key) &&
                      <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                      )
                    }
                  </tr>
                )
              :
                this.state.customer_headers.length > 0 &&
                  <div style={{height:500}}>
                    <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
                  </div>
              }
            </table>
          :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%'}}> <Spinner size="50" /></div>
            </div>
          }
        </div>
        
        <table id="table-to" style={{display:'none'}}>
          <tr> 
            {headers.map((head)=><th>{head}</th>)}
          </tr>
          {this.state.excel_data.map((data)=>
            <tr>
              { data.map((each,key)=>
                tab_index.includes(key) &&
                <td >{each}</td>
                )
              }
            </tr>
          )}
        </table>

      </div>
    )
  }

  

  onCustomerClick(){
    this.setState({customer_details:true,paid_customer:false})
  }

  onPaidCustomerClick(){
    this.setState({paid_customer:true,customer_details:false})
  }


  numberWithCommas(x) {
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return x.toLocaleString('en-IN');
  }
  

  render() {
    console.log('CustomerDetails props',this.props)

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    console.log('customer_data',this.state.customer_data)
    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    const cust_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const book_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const rev_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'

    const StyledRoot = styled.div`
      padding: 0px;
      display: flex;
      flex-direction: row;
      margin-Bottom:5px;
      `
    const StyledContainer = styled.div`
      width: 100%;
      padding:4px;
      
      `
    console.log(this.state)

    return(
      <div >
        <div className='col-md-12'>
          {this.state.customer_details  &&
            this.renderCustomers()
          }

        </div>  

      </div>
    );
  }
}

export default CustomerDetails;




const Tabs = styled.span`
  color: black ;
  background-color:beige;
  transition:0.5s;
  border: 2px solid green;
  padding: 6px;
  font-weight: 700;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  margin-top:20px;
  width: 100%;
`

const SubTabs = styled.span`
  color: black ;
  background-color: azure;
  transition:0.5s;
  border: 2px solid green;
  padding: 6px;
  font-weight: 700;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  margin-top:20px;
  width: 100%;
`








// WEBPACK FOOTER //
// ./src/app/views/centerportal/customerDetails/CustomerDetails.js